<template>
	<div class="pwidth">
	    <div class=" arrow l-h-50 m-t-10 m-b-10">
	        <el-breadcrumb separator-class="el-icon-arrow-right">
	            <el-breadcrumb-item>你所在的位置：</el-breadcrumb-item>
	            <el-breadcrumb-item> 企业资质</el-breadcrumb-item>
	
	        </el-breadcrumb>
	    </div>
	
	    <div class="m-b-20  bg-f min-h-500" >
			<div class="flex start m-r-20 p-20">
				<div class="m-r-20"v-for="(item,index) in certificates">
					<div class="w-300 h-200  p-10 border-a rad-5" >
						<img class="w100 h100" :src="item.imgurl" >
					</div>
					<div class=" l-h-50 f-22 tc">{{item.cname}}</div>
				</div>
			</div>
			
			<div v-if="!certificates.length" class="tc ">
				<img class="w-200 h-150 m-t-100 c-9" src="../../assets/img/sc-1.png" >
				<p>暂无数据</p>
			</div>
		 
	    </div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				certificates:[]
			}
		},
		created: function created() {
			this.getcertificates()
		},
		methods: {

			getcertificates(){
				this.requset('/baseinfo/certificates', ).then(res=> {
					this.certificates=res.data
					
				})
			},

		}
	}
</script>

<style>
	.el-form-item__label{color:#666;}
</style>
